import classNames from 'classnames';

import Section from '../components/Section';
import { linkClassNames, marginsSecondaryClassNames } from '../utils/style';

const pClassNames = classNames(marginsSecondaryClassNames, 'not-last:mb-5');

const SectionProjects = () => (
  <Section title="Projets Personnels">
    <p className={pClassNames}>
      Je développe régulièrement des apps web personnelles, qui me permettent d'explorer de nouvelles technologies tout en nourrissant mes
      centres d'intérêt.
      <br />
      Mon dernier projet en date,{' '}
      <a className={linkClassNames} href="https://games.marcmalignan.com" target="_blank">
        games.marcmalignan.com
      </a>
      , est une app <b>React / Node.js</b> combinant API publiques et visualisation de données. Il me permet d'expérimenter différentes
      utilisations de l'IA : <b>développement assisté par IA</b>, configuration d'agents et collecte automatisée de données.
    </p>
    <p className={pClassNames}>
      Passionné d'art et plus particulièrement de <b>photographie</b>, j'ai récemment réalisé mon portfolio en ligne (
      <a className={linkClassNames} href="https://marcmalignan.com" target="_blank">
        marcmalignan.com
      </a>
      ), ainsi que le site pro de mon frère, pianiste concertiste (
      <a className={linkClassNames} href="https://dimitrimalignan.com" target="_blank">
        dimitrimalignan.com
      </a>
      ).
    </p>
    <p className={pClassNames}>
      Par ailleurs je suis auditeur en <b>histoire de l'art</b> à l'École du Louvre depuis plusieurs années et grand amateur de musique
      live.
    </p>
  </Section>
);

export default SectionProjects;
